export const profitWorkspaceEn = {
  loadError: "Could not load the profit report. Please try again.",
  title: "PI profit summary",
  view: { order: "By document", product: "By product code" },
  scope: { normal: "Normal PIs", adminOnly: "Administrator-only PIs", all: "All PIs" },
  noRows: "No product line in this period.",
  invoicedOnly: "Invoiced only",
  productBasis: "Same period, filters and cost formula as the document view. A code whose lines have no cost shows no margin.",
  productCode: "Product code",
  piCount: "Proforma invoices",
  costUnknown: "{{count}} line(s) without cost",
  documentAdjustments: "Document-level upcharge/discount not attributed to any product code: {{amount}}",
  basis:
    "PI order revenue and estimated goods margin. Freight, tax and operating expenses are excluded. This is not recognized sales or net profit. Currencies are never converted or combined.",
  filters: "Report filters",
  searchPlaceholder: "Search PI, customer or PO",
  allCustomers: "All customers",
  allCurrencies: "All currencies",
  unavailableCustomer: "Unavailable customer",
  customerError: "Could not load customer options.",
  coverage: "Cost coverage",
  profitStateLabel: "Margin result",
  sortLabel: "Sort within each currency",
  sortWithinCurrency:
    "Each currency is ordered separately. Summaries cover all filtered PIs.",
  resetFilters: "Reset filters",
  exportPage: "Export this page",
  exportFiltered: "Export all filtered",
  preview: "Print preview",
  outputError:
    "Could not create the output. Please try again and allow pop-ups for printing.",
  invalidRange: "Enter a valid date range with the start on or before the end.",
  refreshing:
    "Updating report… The displayed report is the previous response; export is unavailable until the update finishes.",
  generatedAt: "Generated {{at}}",
  reportPeriod: "PI dates: {{from}} – {{to}}",
  savedPreview:
    "Preview of the report generated {{at}}. This preview keeps that response until closed.",
  currencySummary: "{{currency}} summary",
  orderCount: "{{count}} PIs",
  revenue: "PI order revenue",
  cost: "Estimated goods cost",
  margin: "Estimated goods margin",
  marginPct: "Goods margin %",
  pricedRevenue: "Revenue with complete cost",
  pricedCost: "Fully costed PI goods cost",
  pricedMargin: "Fully costed PI margin",
  allFilteredPis: "All filtered PIs in this currency",
  pricedScope: "Only PIs with complete cost coverage",
  unknownMargin: "Margin % unknown",
  unknown: "Unknown",
  coverageCounts:
    "PO: {{po}} · Mixed: {{mixed}} · Catalog: {{catalog}} · Missing: {{missing}}",
  incompleteScope:
    "{{count}} PIs with missing costs (revenue {{revenue}}) are excluded from the fully costed totals. Their margin is unknown.",
  ledgerCaption:
    "Filtered PI orders, grouped by currency. Amounts are not combined across currencies.",
  rowNumber: "Row number",
  inspectPi: "Inspect cost sources for {{pi}}",
  costDetail: "Cost calculation details",
  openPi: "Open PI",
  missingExplanation:
    "Cost coverage is incomplete. Known goods cost: {{known}}. Full cost and margin remain unknown; missing cost is not zero.",
  quantityCoverage:
    "PO {{po}} · Catalog {{catalog}} · Missing {{missing}} {{unit}}",
  source: "Cost source",
  unitPrice: "Unit cost",
  capturedAt: "Captured at",
  sourceUpdatedAt: "Source updated at",
  catalogCapture: "Captured catalog cost",
  legacyBaseline: "Legacy baseline",
  noCostSource: "No usable cost source is available for this item.",
  linkedPos: "Linked POs",
  poExcluded:
    "PO freight and tax are excluded. Draft POs are estimates; cancelled POs do not contribute goods costs.",
  unresolvedIssue:
    "This cost source needs review. Check the linked PI and PO details.",
  costStatus: {
    all: "All cost coverage",
    po: "PO covered",
    mixed: "Mixed / draft estimate",
    catalog: "Catalog estimate",
    missing: "Missing cost",
  },
  profitState: {
    all: "All margin results",
    profit: "Positive margin",
    loss: "Negative margin",
    breakeven: "Break-even",
    unknown: "Unknown margin",
  },
  sort: {
    "-margin": "Highest margin",
    margin: "Lowest margin",
    "-date": "Newest PI",
    date: "Oldest PI",
    "-revenue": "Highest revenue",
    cost: "Lowest goods cost",
    "-marginPct": "Highest margin %",
  },
  issues: {
    missing_catalog_cost:
      "No usable captured catalog cost covers the remaining quantity.",
    currency_mismatch:
      "Source currency differs from the PI currency; no currency conversion is applied.",
    unit_mismatch:
      "Source unit differs from the PI unit; no unit conversion is applied.",
    missing_unit: "The cost source has no usable unit.",
    unmatched_po_line: "A linked PO line could not be matched to a PI item.",
    ambiguous_po_line:
      "A PO line matches more than one PI item and cannot be assigned safely.",
    draft_po: "Draft PO prices are estimates, not confirmed purchasing costs.",
    excess_po_quantity:
      "PO quantity exceeds the PI item quantity; only the PI quantity contributes to its goods cost.",
    legacy_cost_baseline:
      "The catalog capture is a migration baseline, not a historical cost at the original PI date.",
    po_charges_excluded: "PO freight and tax are excluded from goods cost.",
    po_quantity_zero:
      "A PO line has zero quantity and contributes no cost coverage.",
    missing_line:
      "A source line is missing; complete cost coverage cannot be verified.",
    cancelled_po:
      "Cancelled POs are excluded; remaining quantity uses captured catalog cost when available.",
    invalid_cost: "A source contains an invalid cost and cannot be used.",
  },
  printTitle: "Profit report",
  scopePage: "Current page only",
  scopeFiltered: "All matching orders",
  goodsCostBasis:
    "Estimated PI goods margin using agreed PO goods prices and saved catalogue cost. This is not cash profit or accounting COGS.",
  snapshotWarning:
    "Snapshot: current PO values can change older orders. Catalogue cost uses its first saved capture; legacy baselines are labelled in source details.",
  excludedCosts:
    "Excludes PO shipping, PO tax and operating expenses. Currencies remain separate; no FX conversion.",
  completeCostOnly:
    "Cost and margin totals include only orders with complete cost.",
  separateCurrencies: "No combined currency total",
  incompleteRevenue: "Revenue excluded from margin totals",
  filteredTotal: "Filtered total",
  emptyOutput: "No matching orders",
  sourceUpdated: "Updated",
  sourceCaptured: "Captured",
  exportCurrency: "Currency",
  exportPi: "PI number",
  exportPiId: "PI ID",
  exportDate: "Order date",
  exportCustomer: "Customer",
  exportCustomerId: "Customer ID",
  exportPo: "Linked POs",
  exportQuantity: "Quantity by unit",
  exportRevenue: "Revenue",
  exportCost: "Goods cost",
  exportMargin: "Goods margin",
  exportMarginPct: "Margin %",
  exportKnownCost: "Known cost (including partial)",
  exportCostStatus: "Cost source quality",
  exportSourceDetails: "Cost source details",
  exportIssues: "Cost notes",
  exportScope: "Export scope",
  exportFrom: "Requested period from",
  exportTo: "Requested period to",
  exportGenerated: "Generated at",
  exportFilters: "Applied filters",
  exportBasis: "Cost basis",
  exportSnapshot: "Snapshot caveat",
  exportExclusions: "Excluded costs",
  exportCoverage: "PO source coverage",
};

export const profitWorkspaceVi = {
  loadError: "Không tải được báo cáo lợi nhuận. Vui lòng thử lại.",
  title: "Tổng hợp lợi nhuận PI",
  view: { order: "Theo chứng từ", product: "Theo mã hàng" },
  scope: { normal: "PI thường", adminOnly: "Chỉ PI của quản trị viên", all: "Tất cả PI" },
  noRows: "Không có dòng hàng nào trong kỳ này.",
  invoicedOnly: "Chỉ đã có hóa đơn",
  productBasis: "Cùng kỳ, cùng bộ lọc và cùng công thức vốn với bảng theo chứng từ. Mã nào còn dòng chưa biết vốn thì không hiện lãi.",
  productCode: "Mã hàng",
  piCount: "Số hóa đơn chiếu lệ",
  costUnknown: "{{count}} dòng chưa có vốn",
  documentAdjustments: "Phần tăng/giảm giá ghi ở đầu chứng từ, không thuộc mã hàng nào: {{amount}}",
  basis:
    "Doanh thu đơn PI và lãi hàng hóa ước tính. Không bao gồm vận chuyển, thuế và chi phí hoạt động. Đây không phải doanh thu đã ghi nhận hay lợi nhuận ròng. Không quy đổi hoặc cộng gộp các loại tiền.",
  filters: "Bộ lọc báo cáo",
  searchPlaceholder: "Tìm PI, khách hàng hoặc PO",
  allCustomers: "Tất cả khách hàng",
  allCurrencies: "Tất cả loại tiền",
  unavailableCustomer: "Khách hàng không khả dụng",
  customerError: "Không tải được danh sách khách hàng.",
  coverage: "Mức độ đủ giá vốn",
  profitStateLabel: "Kết quả lãi",
  sortLabel: "Sắp xếp trong từng loại tiền",
  sortWithinCurrency:
    "Sắp xếp riêng từng loại tiền. Tổng hợp bao gồm tất cả PI khớp bộ lọc.",
  resetFilters: "Đặt lại bộ lọc",
  exportPage: "Xuất trang này",
  exportFiltered: "Xuất tất cả kết quả lọc",
  preview: "Xem trước bản in",
  outputError:
    "Không tạo được bản xuất. Vui lòng thử lại và cho phép cửa sổ bật lên để in.",
  invalidRange:
    "Nhập khoảng ngày hợp lệ, ngày bắt đầu không được sau ngày kết thúc.",
  refreshing:
    "Đang cập nhật… Báo cáo hiển thị là kết quả trước đó; chức năng xuất tạm khóa đến khi cập nhật xong.",
  generatedAt: "Tạo lúc {{at}}",
  reportPeriod: "Ngày PI: {{from}} – {{to}}",
  savedPreview:
    "Bản xem trước của báo cáo tạo lúc {{at}}. Nội dung này được giữ nguyên đến khi đóng.",
  currencySummary: "Tổng hợp {{currency}}",
  orderCount: "{{count}} PI",
  revenue: "Doanh thu đơn PI",
  cost: "Giá vốn hàng hóa ước tính",
  margin: "Lãi hàng hóa ước tính",
  marginPct: "Tỷ lệ lãi hàng hóa %",
  pricedRevenue: "Doanh thu đủ giá vốn",
  pricedCost: "Giá vốn hàng hóa của PI đủ giá vốn",
  pricedMargin: "Lãi của PI đủ giá vốn",
  allFilteredPis: "Tất cả PI khớp bộ lọc trong loại tiền này",
  pricedScope: "Chỉ các PI có đủ giá vốn",
  unknownMargin: "Chưa xác định tỷ lệ lãi",
  unknown: "Chưa xác định",
  coverageCounts:
    "PO: {{po}} · Kết hợp: {{mixed}} · Danh mục: {{catalog}} · Thiếu: {{missing}}",
  incompleteScope:
    "{{count}} PI thiếu giá vốn (doanh thu {{revenue}}) không được tính vào các tổng của PI đủ giá vốn. Lãi của các PI này chưa xác định.",
  ledgerCaption:
    "Đơn PI khớp bộ lọc, nhóm theo loại tiền. Không cộng gộp tiền giữa các loại tiền tệ.",
  rowNumber: "Số thứ tự",
  inspectPi: "Xem nguồn giá vốn của {{pi}}",
  costDetail: "Chi tiết tính giá vốn",
  openPi: "Mở PI",
  missingExplanation:
    "Chưa đủ giá vốn. Giá vốn hàng hóa đã biết: {{known}}. Tổng giá vốn và lãi chưa xác định; thiếu giá vốn không có nghĩa là bằng 0.",
  quantityCoverage:
    "PO {{po}} · Danh mục {{catalog}} · Thiếu {{missing}} {{unit}}",
  source: "Nguồn giá vốn",
  unitPrice: "Đơn giá vốn",
  capturedAt: "Thời điểm lưu giá",
  sourceUpdatedAt: "Thời điểm cập nhật nguồn",
  catalogCapture: "Giá vốn danh mục đã lưu",
  legacyBaseline: "Mốc dữ liệu cũ",
  noCostSource: "Mặt hàng này chưa có nguồn giá vốn sử dụng được.",
  linkedPos: "PO liên kết",
  poExcluded:
    "Không tính phí vận chuyển và thuế PO. PO nháp là ước tính; PO đã hủy không đóng góp giá vốn hàng hóa.",
  unresolvedIssue:
    "Nguồn giá vốn này cần kiểm tra. Hãy xem chi tiết PI và PO liên kết.",
  costStatus: {
    all: "Tất cả mức độ giá vốn",
    po: "Đủ từ PO",
    mixed: "Kết hợp / PO nháp",
    catalog: "Ước tính danh mục",
    missing: "Thiếu giá vốn",
  },
  profitState: {
    all: "Tất cả kết quả lãi",
    profit: "Lãi dương",
    loss: "Lãi âm",
    breakeven: "Hòa vốn",
    unknown: "Chưa xác định lãi",
  },
  sort: {
    "-margin": "Lãi cao nhất",
    margin: "Lãi thấp nhất",
    "-date": "PI mới nhất",
    date: "PI cũ nhất",
    "-revenue": "Doanh thu cao nhất",
    cost: "Giá vốn thấp nhất",
    "-marginPct": "Tỷ lệ lãi cao nhất",
  },
  issues: {
    missing_catalog_cost:
      "Không có giá vốn danh mục đã lưu phù hợp cho số lượng còn lại.",
    currency_mismatch:
      "Loại tiền nguồn khác PI; không áp dụng quy đổi tiền tệ.",
    unit_mismatch: "Đơn vị nguồn khác PI; không áp dụng quy đổi đơn vị.",
    missing_unit: "Nguồn giá vốn không có đơn vị hợp lệ.",
    unmatched_po_line: "Không ghép được một dòng PO liên kết với mặt hàng PI.",
    ambiguous_po_line:
      "Một dòng PO khớp nhiều mặt hàng PI nên không thể phân bổ chắc chắn.",
    draft_po: "Giá PO nháp là ước tính, chưa phải giá mua được xác nhận.",
    excess_po_quantity:
      "Số lượng PO vượt mặt hàng PI; chỉ tính giá vốn cho số lượng PI.",
    legacy_cost_baseline:
      "Giá danh mục lưu khi chuyển dữ liệu không phải giá lịch sử tại ngày PI ban đầu.",
    po_charges_excluded:
      "Không tính vận chuyển và thuế PO vào giá vốn hàng hóa.",
    po_quantity_zero:
      "Dòng PO có số lượng bằng 0 nên không đóng góp mức độ đủ giá vốn.",
    missing_line: "Thiếu dòng nguồn; không thể xác minh đầy đủ giá vốn.",
    cancelled_po:
      "Bỏ qua PO đã hủy; số lượng còn lại dùng giá danh mục đã lưu nếu có.",
    invalid_cost: "Nguồn có giá vốn không hợp lệ nên không thể sử dụng.",
  },
  printTitle: "Báo cáo lợi nhuận",
  scopePage: "Chỉ trang hiện tại",
  scopeFiltered: "Tất cả đơn khớp bộ lọc",
  goodsCostBasis:
    "Lợi nhuận hàng hóa PI ước tính theo giá hàng đã thỏa thuận trên PO và giá vốn danh mục đã lưu. Không phải lợi nhuận tiền mặt hay giá vốn kế toán.",
  snapshotWarning:
    "Ảnh chụp dữ liệu: cập nhật PO hiện tại có thể thay đổi đơn cũ. Giá vốn danh mục dùng bản lưu đầu tiên; mốc dữ liệu cũ được ghi rõ trong chi tiết nguồn.",
  excludedCosts:
    "Không gồm vận chuyển PO, thuế PO và chi phí vận hành. Tách riêng từng tiền tệ, không quy đổi tỷ giá.",
  completeCostOnly: "Tổng giá vốn và lợi nhuận chỉ gồm đơn đủ giá vốn.",
  separateCurrencies: "Không cộng gộp các tiền tệ",
  incompleteRevenue: "Doanh thu chưa tính vào tổng lợi nhuận",
  filteredTotal: "Tổng theo bộ lọc",
  emptyOutput: "Không có đơn khớp bộ lọc",
  sourceUpdated: "Cập nhật",
  sourceCaptured: "Lưu lần đầu",
  exportCurrency: "Tiền tệ",
  exportPi: "Số PI",
  exportPiId: "ID PI",
  exportDate: "Ngày đơn",
  exportCustomer: "Khách hàng",
  exportCustomerId: "ID khách hàng",
  exportPo: "PO liên kết",
  exportQuantity: "Số lượng theo đơn vị",
  exportRevenue: "Doanh thu",
  exportCost: "Giá vốn hàng hóa",
  exportMargin: "Lợi nhuận hàng hóa",
  exportMarginPct: "Biên lợi nhuận %",
  exportKnownCost: "Giá vốn đã biết (gồm phần chưa đủ)",
  exportCostStatus: "Chất lượng nguồn giá vốn",
  exportSourceDetails: "Chi tiết nguồn giá vốn",
  exportIssues: "Ghi chú giá vốn",
  exportScope: "Phạm vi xuất",
  exportFrom: "Kỳ yêu cầu từ",
  exportTo: "Kỳ yêu cầu đến",
  exportGenerated: "Tạo lúc",
  exportFilters: "Bộ lọc đã áp dụng",
  exportBasis: "Cơ sở giá vốn",
  exportSnapshot: "Lưu ý dữ liệu chụp",
  exportExclusions: "Chi phí không tính",
  exportCoverage: "Độ phủ nguồn PO",
};

export const profitWorkspaceZh = {
  loadError: "无法加载利润报表，请重试。",
  title: "PI 利润汇总",
  view: { order: "依单据", product: "依产品编号" },
  scope: { normal: "一般PI", adminOnly: "仅限管理员的PI", all: "全部PI" },
  noRows: "此期间没有产品明细。",
  invoicedOnly: "仅已开发票",
  productBasis: "与单据视图采用相同期间、筛选与成本公式。若某编号仍有未知成本的明细，则不显示毛利。",
  productCode: "产品编号",
  piCount: "形式发票数",
  costUnknown: "{{count}} 条明细无成本",
  documentAdjustments: "整单加价／折扣，不归属于任何产品编号：{{amount}}",
  basis:
    "PI 订单收入及估计货品毛利。不包括运费、税额和运营费用。这并非已确认销售收入或净利润。不同币种不换算或合并。",
  filters: "报表筛选",
  searchPlaceholder: "搜索 PI、客户或 PO",
  allCustomers: "所有客户",
  allCurrencies: "所有币种",
  unavailableCustomer: "客户不可用",
  customerError: "无法加载客户选项。",
  coverage: "成本覆盖情况",
  profitStateLabel: "毛利结果",
  sortLabel: "各币种内排序",
  sortWithinCurrency: "各币种分别排序。汇总涵盖所有符合筛选的 PI。",
  resetFilters: "重置筛选",
  exportPage: "导出本页",
  exportFiltered: "导出所有筛选结果",
  preview: "打印预览",
  outputError: "无法生成输出。请重试，并允许弹出窗口以打印。",
  invalidRange: "请输入有效日期范围，开始日期不可晚于结束日期。",
  refreshing: "正在更新… 目前显示上次的结果；更新完成前无法导出。",
  generatedAt: "生成于 {{at}}",
  reportPeriod: "PI 日期：{{from}} – {{to}}",
  savedPreview: "此预览使用 {{at}} 生成的报表，内容会保留至关闭。",
  currencySummary: "{{currency}} 汇总",
  orderCount: "{{count}} 张 PI",
  revenue: "PI 订单收入",
  cost: "估计货品成本",
  margin: "估计货品毛利",
  marginPct: "货品毛利率 %",
  pricedRevenue: "成本完整订单收入",
  pricedCost: "成本完整 PI 货品成本",
  pricedMargin: "成本完整 PI 毛利",
  allFilteredPis: "此币种所有符合筛选的 PI",
  pricedScope: "仅包括成本完整的 PI",
  unknownMargin: "毛利率未能确定",
  unknown: "未知",
  coverageCounts:
    "PO：{{po}} · 混合：{{mixed}} · 目录：{{catalog}} · 缺失：{{missing}}",
  incompleteScope:
    "{{count}} 张 PI 缺少成本（收入 {{revenue}}），不计入成本完整合计，其毛利未能确定。",
  ledgerCaption: "符合筛选的 PI 订单，按币种分组。不同币种金额不合并。",
  rowNumber: "序号",
  inspectPi: "查看 {{pi}} 的成本来源",
  costDetail: "成本计算明细",
  openPi: "打开 PI",
  missingExplanation:
    "成本尚未完整。已知货品成本：{{known}}。完整成本与毛利仍未能确定；缺少成本并不代表成本为零。",
  quantityCoverage: "PO {{po}} · 目录 {{catalog}} · 缺失 {{missing}} {{unit}}",
  source: "成本来源",
  unitPrice: "成本单价",
  capturedAt: "价格保存时间",
  sourceUpdatedAt: "来源更新时间",
  catalogCapture: "已保存目录成本",
  legacyBaseline: "旧数据基准",
  noCostSource: "此明细没有可用的成本来源。",
  linkedPos: "关联 PO",
  poExcluded:
    "不包括 PO 运费及税额。草稿 PO 为估计成本；已取消 PO 不计入货品成本。",
  unresolvedIssue: "此成本来源需要复核。请检查关联 PI 和 PO 明细。",
  costStatus: {
    all: "所有成本覆盖情况",
    po: "PO 完整覆盖",
    mixed: "混合／草稿估计",
    catalog: "目录估计",
    missing: "缺少成本",
  },
  profitState: {
    all: "所有毛利结果",
    profit: "正毛利",
    loss: "负毛利",
    breakeven: "收支平衡",
    unknown: "毛利未能确定",
  },
  sort: {
    "-margin": "毛利最高",
    margin: "毛利最低",
    "-date": "最新 PI",
    date: "最早 PI",
    "-revenue": "收入最高",
    cost: "货品成本最低",
    "-marginPct": "毛利率最高",
  },
  issues: {
    missing_catalog_cost: "剩余数量没有可用的已保存目录成本。",
    currency_mismatch: "来源币种与 PI 不同；不进行货币换算。",
    unit_mismatch: "来源单位与 PI 不同；不进行单位换算。",
    missing_unit: "成本来源没有有效单位。",
    unmatched_po_line: "关联 PO 明细无法匹配到 PI 明细。",
    ambiguous_po_line: "PO 明细匹配多个 PI 明细，无法可靠分配。",
    draft_po: "草稿 PO 价格是估计值，并非已确认采购成本。",
    excess_po_quantity: "PO 数量超过 PI 明细数量；仅以 PI 数量计算货品成本。",
    legacy_cost_baseline:
      "目录价格保存于数据迁移时，并非原始 PI 日期的历史成本。",
    po_charges_excluded: "PO 运费和税额不计入货品成本。",
    po_quantity_zero: "PO 明细数量为零，不提供成本覆盖。",
    missing_line: "来源明细缺失，无法验证完整成本。",
    cancelled_po: "已取消 PO 不计入成本；剩余数量使用可用的已保存目录成本。",
    invalid_cost: "来源成本无效，无法使用。",
  },
  printTitle: "利润报表",
  scopePage: "仅当前页面",
  scopeFiltered: "所有符合筛选条件的订单",
  goodsCostBasis:
    "依 PO 约定货品价格及已保存目录成本估算 PI 货品毛利。此数字并非现金利润或会计销售成本。",
  snapshotWarning:
    "数据快照：目前 PO 更新可能改变旧订单。目录成本采用首次保存值；旧数据基准会在来源明细中标示。",
  excludedCosts:
    "不含 PO 运费、PO 税额及运营费用。币种分开列示，不作汇率换算。",
  completeCostOnly: "成本与毛利合计仅包含成本完整的订单。",
  separateCurrencies: "不合并不同币种总额",
  incompleteRevenue: "未计入毛利合计的收入",
  filteredTotal: "筛选合计",
  emptyOutput: "没有符合条件的订单",
  sourceUpdated: "更新",
  sourceCaptured: "首次保存",
  exportCurrency: "币种",
  exportPi: "PI 编号",
  exportPiId: "PI ID",
  exportDate: "订单日期",
  exportCustomer: "客户",
  exportCustomerId: "客户 ID",
  exportPo: "关联 PO",
  exportQuantity: "依单位列示数量",
  exportRevenue: "收入",
  exportCost: "货品成本",
  exportMargin: "货品毛利",
  exportMarginPct: "毛利率 %",
  exportKnownCost: "已知成本（含部分成本）",
  exportCostStatus: "成本来源质量",
  exportSourceDetails: "成本来源明细",
  exportIssues: "成本备注",
  exportScope: "导出范围",
  exportFrom: "查询开始日期",
  exportTo: "查询结束日期",
  exportGenerated: "生成时间",
  exportFilters: "应用筛选条件",
  exportBasis: "成本基础",
  exportSnapshot: "快照说明",
  exportExclusions: "未计入成本",
  exportCoverage: "PO 来源覆盖率",
};
